import { render, staticRenderFns } from "./Permanencia.vue?vue&type=template&id=050a1820&scoped=true&"
import script from "./Permanencia.vue?vue&type=script&lang=js&"
export * from "./Permanencia.vue?vue&type=script&lang=js&"
import style0 from "./Permanencia.vue?vue&type=style&index=0&id=050a1820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a1820",
  null
  
)

export default component.exports